import * as React from 'react';

import {withSystem, TypeImplementation} from '@packages/systems/wfdl';

import {ExpressionEditor} from '@packages/systems/ExpressionEditor-utils';
import {TTypeConstructor} from '@packages/systems/wfdl-ast';
import {qualify, pluginName, typeName} from '@packages/systems/wfdl-Qualified';

import TooltipControl from '@packages/systems/design-system/TooltipControl';
import {styled, styledDiv} from '@packages/utilities/styled';
import {StyledHelpIcon} from './icons';
import {LogicLabel} from '@packages/systems/flows/shared';

const StyledLabel = styled(LogicLabel)(({theme: {gutters}}) => ({
  display: 'grid',
  gridTemplateColumns: `max-content ${gutters.x16}px`,
  gridColumnGap: gutters.x4,
  alignItems: 'start',

  overflowY: 'visible',
  maxHeight: `${gutters.x16}px`,
  marginBottom: gutters.x4,
}));

const StyledTooltipControl = styled(TooltipControl)(({theme: {gutters}}) => ({
  marginLeft: gutters.x4,
  justifySelf: 'center',
  marginTop: '-2px',
}));

const TooltipContent = styledDiv(({theme: {gutters}}) => ({
  maxWidth: gutters.x4 * 56, // 224
}));

const typeofCollaboratorList = withSystem(
  {labelVariant: 'hidden'},
  TTypeConstructor(
    qualify(pluginName('Collaborators'), typeName('CollaboratorsList'))
  )
);

export const SendNotification = TypeImplementation.Alias({
  type: typeofCollaboratorList,
  system: {bindUIVariant: 'custom'},
  render: ({expr, dispatch}) => {
    return (
      <div>
        <StyledLabel label="Send to" required>
          <StyledTooltipControl
            icon={<StyledHelpIcon />}
            aria-hidden
            content={
              <TooltipContent>
                Email notifications can only be sent to project collaborators.
                Manage collaborators and email settings from your project
                settings.
              </TooltipContent>
            }
            alternate
          />
        </StyledLabel>

        {/* CollaboratorsList UI*/}
        <ExpressionEditor expression={expr} dispatch={dispatch} />
      </div>
    );
  },
});
